import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import AppBarContainer from "../../../components/shared/AppBarContainer";
import PageContentContainer from "../../../components/shared/PageContentContainer";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRequest } from "../../../api/utils/useRequest";
import { BalootUserAPIs, BalootUserV2APIs } from "../../../api/APIs";
import { LoadingButton } from "@mui/lab";
import BottomFullWidthButtonContainer from "../../../components/shared/BottomFullWidthButtonContainer";
import { useSnackBar } from "../../../context/SnackBarContext";
import moment from "moment-jalaali";
import { CancelOutlined } from "@mui/icons-material";
import createCache from "@emotion/cache";
import { SetBirthDateBottomSheet } from "../../../components/profile/SetBirthDateBottomSheet";
import CustomTextSkeleton from "../../../components/shared/CustomTextSkeleton";
import CustomRectangularSkeleton from "../../../components/shared/CustomRectangularSkeleton";
import {
  isNationalIdValid,
  onlyHasPersianChar,
} from "../../../utils/validations";
import { removeNonNumeric } from "../../../utils/Utils";

const cacheltr = createCache({
  key: "muiltr",
  stylisPlugins: [],
});

function ProfileSettingPersonalPage() {
  const navigate = useNavigate();
  const dateInput = useRef(null);
  const openSnack = useSnackBar();
  const [birthDate, setBirthDate] = useState("");
  const [editedBirthDate, setEditedBirthDate] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobile, setMobile] = useState("");
  const [nationalId, setNationalId] = useState("");
  const [isPartyConfirmed, setIsPartyConfirmed] = useState(false);
  const [isIndividualConfirmed, setIsIndividualConfirmed] = useState(false);

  const [openDrawer, setOpenDrawer] = useState(false);

  const {
    loading: getLoading,
    result,
    apiCall: getPersonalInfo,
  } = useRequest(BalootUserV2APIs.getPersonalInfo, true);

  const { loading: updateLoading, apiCall: updatePersonalInfo } = useRequest(
    BalootUserAPIs.updatePersonalInfo
  );

  useEffect(() => {
    getPersonalInfo({
      onSuccess: (response) => {
        setBirthDate(response.birthDate || "");
        setEditedBirthDate(response.birthDate || "");
        setNationalId(response.nationalId || "");
        setFirstName(response.firstName || "");
        setLastName(response.lastName || "");
        setMobile(response.mobile || "");
        setIsPartyConfirmed(response.partyConfirmed);
        setIsIndividualConfirmed(response.individualConfirmed);
      },
    });
  }, []);

  const handleSubmit = () => {
    updatePersonalInfo({
      data: {
        birthDate: editedBirthDate,
        firstName,
        lastName,
        nationalId,
      },
      onSuccess: () => {
        openSnack(true, { message: "اطلاعات شما با موفقیت به‌روزرسانی شد." });
        navigate(-1);
      },
    });
  };

  return (
    <>
      <AppBarContainer
        rightElement={
          <IconButton onClick={() => navigate(-1)}>
            <ArrowForward sx={{ color: "common.white" }} />
          </IconButton>
        }
        centerElement={
          <Typography variant="h5" color={"common.white"}>
            اطلاعات کاربری
          </Typography>
        }
      />
      <PageContentContainer
        sx={{
          overflow: "auto",
          display: "block",
          pb: `calc(env(safe-area-inset-bottom) + 112px )`,
        }}
      >
        {getLoading ? (
          <>
            <CustomTextSkeleton />
            <CustomRectangularSkeleton />
            <CustomTextSkeleton sx={{ mt: 2 }} />
            <CustomRectangularSkeleton />
            <CustomTextSkeleton sx={{ mt: 2 }} />
            <CustomRectangularSkeleton />
            <CustomTextSkeleton sx={{ mt: 2 }} />
            <CustomRectangularSkeleton />
          </>
        ) : (
          result && (
            <>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography variant="body2" color="grey.2">
                  تلفن همراه
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  py: 1,
                  px: 2,
                  mt: 1,
                  borderRadius: "10px",
                  border: (theme) => `1px solid ${theme.palette.common.black}`,
                }}
              >
                <Typography sx={{ flex: 1 }} variant="body2" color="grey.2">
                  {mobile}
                </Typography>
                <Button
                  variant="contained"
                  size="small"
                  sx={{ color: "common.white" }}
                  onClick={() => {
                    navigate("/app/profile/setting/personal/change-mobile", {
                      replace: true,
                      state: { currentMobile: mobile },
                    });
                  }}
                >
                  تغییر
                </Button>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  mt: "8px",
                }}
              >
                <Typography variant="body2" color="grey.2">
                  نام
                </Typography>
                {isIndividualConfirmed && (
                  <Typography variant="subtitle1" color="primary.main">
                    (تایید شده)
                  </Typography>
                )}
              </Box>
              <TextField
                name="first-name"
                error={firstName.length > 1 && !onlyHasPersianChar(firstName)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {firstName.length > 0 && !isIndividualConfirmed && (
                        <IconButton
                          onClick={() => {
                            setFirstName("");
                          }}
                        >
                          <CancelOutlined sx={{ fontSize: 20 }} />
                        </IconButton>
                      )}
                    </InputAdornment>
                  ),
                }}
                disabled={isIndividualConfirmed}
                value={firstName}
                onChange={(event) => {
                  if (event.target.value === null) {
                    setFirstName("");
                  } else {
                    event.target.value.length < 20 &&
                      setFirstName(event.target.value);
                  }
                }}
                sx={{ mt: "8px" }}
                fullWidth
              />
              <Box
                sx={{
                  mt: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography variant="body2" color="grey.2">
                  نام خانوادگی
                </Typography>
                {isIndividualConfirmed && (
                  <Typography variant="subtitle1" color="primary.main">
                    (تایید شده)
                  </Typography>
                )}
              </Box>
              <TextField
                name="last-name"
                error={lastName.length > 1 && !onlyHasPersianChar(lastName)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {lastName.length > 0 && !isIndividualConfirmed && (
                        <IconButton
                          onClick={() => {
                            setLastName("");
                          }}
                        >
                          <CancelOutlined sx={{ fontSize: 20 }} />
                        </IconButton>
                      )}
                    </InputAdornment>
                  ),
                }}
                disabled={isIndividualConfirmed}
                value={lastName}
                onChange={(event) => {
                  if (event.target.value === null) {
                    setLastName("");
                  } else {
                    event.target.value.length < 20 &&
                      setLastName(event.target.value);
                  }
                }}
                sx={{ mt: "8px" }}
                fullWidth
              />
              <Box
                sx={{
                  mt: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography variant="body2" color="grey.2">
                  کد ملی
                </Typography>
                {isPartyConfirmed && (
                  <Typography variant="subtitle1" color="primary.main">
                    (تایید شده)
                  </Typography>
                )}
              </Box>
              <TextField
                error={
                  nationalId.length === 10 && !isNationalIdValid(nationalId)
                }
                name="nationalId"
                inputProps={{
                  inputMode: "numeric",
                }}
                disabled={isPartyConfirmed}
                value={nationalId}
                onChange={(event) => {
                  if (event.target.value === null) {
                    setNationalId("");
                  } else {
                    event.target.value.length < 11 &&
                      setNationalId(removeNonNumeric(event.target.value));
                  }
                }}
                sx={{ mt: "8px" }}
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {nationalId.length > 0 && !isPartyConfirmed && (
                        <IconButton
                          onClick={() => {
                            setNationalId("");
                          }}
                        >
                          <CancelOutlined sx={{ fontSize: 20 }} />
                        </IconButton>
                      )}
                    </InputAdornment>
                  ),
                }}
              />
              <Box
                sx={{
                  mt: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography variant="body2" color="grey.2">
                  تاریخ تولد
                </Typography>
                {isIndividualConfirmed && (
                  <Typography variant="subtitle1" color="primary.main">
                    (تایید شده)
                  </Typography>
                )}
              </Box>
              <TextField
                name="birthDate"
                ref={dateInput}
                disabled={isIndividualConfirmed}
                onFocus={(event) => {
                  event.target.blur();
                  setOpenDrawer(true);
                }}
                value={
                  Boolean(editedBirthDate)
                    ? moment(editedBirthDate).format("jYYYY/jMM/jDD")
                    : ""
                }
                sx={{ mt: "8px" }}
                fullWidth
              />
            </>
          )
        )}
        <BottomFullWidthButtonContainer>
          <LoadingButton
            loading={updateLoading}
            disabled={
              getLoading ||
              firstName.length < 2 ||
              lastName.length < 2 ||
              !onlyHasPersianChar(firstName) ||
              !onlyHasPersianChar(lastName) ||
              !isNationalIdValid(nationalId)
            }
            onClick={handleSubmit}
            sx={{
              color: "common.white",
              typography: "h3",
            }}
            variant="contained"
            fullWidth
          >
            ثبت
          </LoadingButton>
        </BottomFullWidthButtonContainer>
      </PageContentContainer>
      <SetBirthDateBottomSheet
        open={openDrawer}
        setOpen={setOpenDrawer}
        birthDate={editedBirthDate}
        setBirthDate={setEditedBirthDate}
      />
    </>
  );
}

export default ProfileSettingPersonalPage;
